import { render } from "./DotQueHalfScreen.vue?vue&type=template&id=520073c4&ts=true"
import script from "./DotQueHalfScreen.vue?vue&type=script&lang=ts"
export * from "./DotQueHalfScreen.vue?vue&type=script&lang=ts"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__